const videoWrappers = document.querySelectorAll('.video-wrapper')

videoWrappers.forEach((videoWrapper) => {
  const video = videoWrapper.querySelector('video')
  const playButton = videoWrapper.querySelector('button.play')
  const videoTitle = videoWrapper.querySelector('p.video-title')
  //on first play of video, remove custom play button and video title, thereafter the default controls take over
  video.addEventListener('click', () => {
    if (playButton.hidden) return
    playButton.hidden = true
    videoTitle.hidden = true
    video.play()
    setTimeout(() => {
      //this prevents play being triggered twice - which causes the video not to play at all
      video.setAttribute('controls', 'true')
    }, 100)
  })
})

const popularVideosToggle = document.querySelector(
  'button.toggle-popular-videos'
)

if (popularVideosToggle) {
  const popularVideos = document.querySelector('.popular-videos')

  popularVideosToggle.addEventListener('click', () => {
    popularVideosToggle.classList.toggle('active')
    if (popularVideos.style.maxHeight) {
      popularVideos.style.maxHeight = null
    } else {
      popularVideos.style.maxHeight = popularVideos.scrollHeight + 'px'
    }
  })
}
